import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { TDocFeeStateExclusion } from '../../../interfaces';

const BASE_URL = `/${SERVICES.LENDER}/lenders`;

export const requestCreateDocFee = (lenderId: string, docFee: TDocFeeStateExclusion) => {
  const path = `${BASE_URL}/${lenderId}/docFeeStateExclusion`;

  return mutate(`${BASE_URL}/${lenderId}`, async () => {
    try {
      await axios.put(path, docFee);
      Notistack.successMessage('DocFee - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateDocFee = (lenderId: string, docFee: TDocFeeStateExclusion) => {
  const path = `${BASE_URL}/${lenderId}/docFeeStateExclusion`;

  return mutate(`${BASE_URL}/${lenderId}`, async () => {
    try {
      await axios.patch(path, docFee);
      Notistack.successMessage('DocFee - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteDocFee = (lenderId: string, docFeeId = '') => {
  const path = `${BASE_URL}/${lenderId}/docFeeStateExclusion/${docFeeId}`;

  return mutate(`${BASE_URL}/${lenderId}`, async () => {
    try {
      await axios.delete(path);
      Notistack.successMessage('DocFee - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateTitleToDeal = (lenderId: string, shouldAddTitleFeeToDeal: boolean) => {
  const path = `${BASE_URL}/${lenderId}/update-title-fee-to-deal?shouldAddTitleFeeToDeal=${shouldAddTitleFeeToDeal}`;

  return mutate(`${BASE_URL}/${lenderId}`, async () => {
    try {
      await axios.patch(path);
      Notistack.successMessage('Title Fee updated to deal');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
